var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNfFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#nf_faq_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.26 50c11.19 0 20.26-8.954 20.26-20s-9.07-20-20.26-20C29.07 10 20 18.954 20 30s9.07 20 20.26 20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nf_faq_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE07D",
    d: "M31.755 20.7h8.893a3.418 3.418 0 013.418 3.418v4.438a3.418 3.418 0 01-3.418 3.418h-4.469L34.04 34.42c-.634.725-1.829.276-1.829-.687v-1.758h-.456a3.418 3.418 0 01-3.418-3.418v-4.438a3.418 3.418 0 013.418-3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD064",
    d: "M34 34.462c-.644.662-1.789.212-1.789-.731v-1.757h-.456a3.418 3.418 0 01-3.418-3.418v-4.44a3.417 3.417 0 013.418-3.417h1.492a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418h.457v1.757c0 .3.116.551.295.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3E59F",
    d: "M47.245 26.224h-8.893a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418h4.468l2.14 2.444c.634.725 1.828.277 1.828-.687V37.5h.457a3.418 3.418 0 003.418-3.418v-4.439a3.418 3.418 0 00-3.418-3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95D6A4",
    d: "M39.976 37.5h-1.624a3.418 3.418 0 01-3.418-3.419v-4.439a3.418 3.418 0 013.418-3.418h1.624a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.663 32.023a.337.337 0 00.337-.337v-2.044a3.76 3.76 0 00-3.755-3.755h-2.842v-1.77a3.76 3.76 0 00-3.755-3.755H33.92a.337.337 0 100 .674h6.727a3.083 3.083 0 013.08 3.08v1.771h-5.376a3.76 3.76 0 00-3.755 3.755v3.628l-.81.926a.692.692 0 01-.78.196.692.692 0 01-.459-.661v-1.757a.337.337 0 00-.337-.337h-.456a3.084 3.084 0 01-3.081-3.081v-4.44a3.084 3.084 0 013.081-3.08h.819a.336.336 0 000-.674h-.819a3.76 3.76 0 00-3.755 3.755v4.439a3.76 3.76 0 003.755 3.755h.12v1.42c0 .58.35 1.087.894 1.292a1.371 1.371 0 001.525-.383l.31-.354a3.758 3.758 0 003.748 3.55h4.316l2.038 2.33a1.372 1.372 0 001.525.382 1.37 1.37 0 00.895-1.292v-1.42h.119a3.76 3.76 0 003.755-3.755v-1.048a.337.337 0 10-.674 0v1.048a3.084 3.084 0 01-3.081 3.081h-.456a.337.337 0 00-.337.337v1.757c0 .36-.237.578-.458.661a.69.69 0 01-.78-.196l-2.14-2.444a.335.335 0 00-.253-.115h-4.469a3.083 3.083 0 01-3.08-3.081v-4.439a3.083 3.083 0 013.08-3.081h8.893a3.084 3.084 0 013.081 3.081v2.044c0 .186.151.337.337.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.901 29.776a.428.428 0 00-.399-.267.43.43 0 00-.399.268l-.003.007-1.562 4.103a.336.336 0 10.629.24l.307-.805h2.046l.303.804a.336.336 0 00.434.196.337.337 0 00.196-.434l-1.548-4.103-.004-.009zm-1.17 2.872l.77-2.024.764 2.024h-1.534zm-1.646-2.411a.337.337 0 100-.674h-1.674a.337.337 0 00-.337.337v4.13a.337.337 0 10.674.001v-1.768h1.204a.337.337 0 100-.674h-1.204v-1.352h1.337zm7.005-.689a2.42 2.42 0 00-2.418 2.417 2.42 2.42 0 002.417 2.418c.554 0 1.065-.188 1.473-.502l.386.386a.335.335 0 00.476 0 .336.336 0 000-.476l-.39-.39a2.41 2.41 0 00.473-1.436 2.42 2.42 0 00-2.418-2.417zm0 4.161a1.746 1.746 0 01-1.744-1.744c0-.961.782-1.743 1.743-1.743a1.745 1.745 0 011.461 2.694l-.457-.456a.336.336 0 00-.476 0 .336.336 0 000 .476l.463.463c-.282.195-.623.31-.99.31z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nf_faq_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z",
    transform: "translate(28 19)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "nf_faq_svg__filter0_d",
    width: 80.521,
    height: 80,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default SvgNfFaq;